import React from 'react'
import { Navigate } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { AuthGuard } from '@/features/auth/components/AuthGuard'
import { AppLayout } from '@/features/layout/AppLayout'

// Lazy-loaded pages
const DashboardPage = React.lazy(() =>
  import('@/features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
)
const AssetDetailPage = React.lazy(() =>
  import('@/features/assets/pages/AssetDetailPage').then((m) => ({ default: m.AssetDetailPage }))
)
const TransactionsPage = React.lazy(() =>
  import('@/features/transactions/pages/TransactionsPage').then((m) => ({ default: m.TransactionsPage }))
)
const PortfoliosPage = React.lazy(() =>
  import('@/features/portfolios/pages/PortfoliosPage').then((m) => ({ default: m.PortfoliosPage }))
)
const AuthCallbackPage = React.lazy(() =>
  import('@/features/auth/pages/AuthCallbackPage').then((m) => ({ default: m.AuthCallbackPage }))
)

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <React.Suspense
    fallback={
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    }
  >
    {children}
  </React.Suspense>
)

export const routeDefinitions: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <SuspenseWrapper><DashboardPage /></SuspenseWrapper> },
      { path: 'assets/:id', element: <SuspenseWrapper><AssetDetailPage /></SuspenseWrapper> },
      { path: 'transactions', element: <SuspenseWrapper><TransactionsPage /></SuspenseWrapper> },
      { path: 'portfolios', element: <SuspenseWrapper><PortfoliosPage /></SuspenseWrapper> },
    ],
  },
  {
    path: '/auth/callback',
    element: <SuspenseWrapper><AuthCallbackPage /></SuspenseWrapper>,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]
